
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DenominationDialog extends Serenity.EntityDialog<DenominationRow, any> {
        protected getFormKey() { return DenominationForm.formKey; }
        protected getIdProperty() { return DenominationRow.idProperty; }
        protected getLocalTextPrefix() { return DenominationRow.localTextPrefix; }
        protected getNameProperty() { return DenominationRow.nameProperty; }
        protected getService() { return DenominationService.baseUrl; }
        protected getDeletePermission() { return DenominationRow.deletePermission; }
        protected getInsertPermission() { return DenominationRow.insertPermission; }
        protected getUpdatePermission() { return DenominationRow.updatePermission; }

        protected form = new DenominationForm(this.idPrefix);

    }
}